<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span *ngIf="model.id" jhiTranslate="site-admin.role.modal.edit.header"></span>
        <span *ngIf="!model.id" jhiTranslate="site-admin.role.modal.create.header"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <form name="form" #f="ngForm">
            <div class="mb-3 row">
                <div class="col-sm-12">
                    <span class="mandatory-asterisk"></span> <span jhiTranslate="site-admin.mandatory.fields"></span>
                </div>
            </div>
            <div class="mb-3 row required">
                <label for="roleName" class="col-md-3 col-form-label fw-bold float-end" jhiTranslate="site-admin.role.modal.role.name"></label>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="model.name" #roleName="ngModel" jhi-forbiddenCharactersValidator required name="roleName" id="roleName"
                           pattern="[A-Za-z0-9-\/_*\(\):\.\s]*[A-Za-z0-9-\/_*\(\):\.]+[A-Za-z0-9-\/_*\(\):\.\s]*"
                           title="{{ 'site-admin.role.modal.role.name.title' | translate}}"
                           placeholder="" maxlength="100">
                </div>
            </div>
            <div class="mb-3 row">
                <label for="description" class="col-md-3 col-form-label fw-bold float-end" jhiTranslate="site-admin.role.modal.description"></label>
                <div class="col-sm-9">
                    <input type="text" class="form-control" [(ngModel)]="model.description" #description="ngModel" jhi-forbiddenCharactersValidator name="description" id="description"
                           pattern="[A-Za-z0-9-\/_*\(\):\.\s]*"
                           title="{{ 'site-admin.role.modal.description.title' | translate}}"
                           placeholder="" maxlength="255">
                </div>
            </div>
            <div class="mb-3 row required">
                <label for="roleType" class="col-md-3 col-form-label fw-bold float-end" jhiTranslate="site-admin.role.modal.role.type"></label>
                <div class="col-xs-9 col-md-9">
                    <select class="form-select" [(ngModel)]="roleTypeId" #roleTypeInput="ngModel" required name="roleType" id="roleType"
                            (ngModelChange)="onChangeRoleType()" [disabled]="roleTypeDisabled">
                        <option value=""><span jhiTranslate="site-admin.role.modal.dropdown.role.type"></span></option>
                        <option *ngFor="let roleType of roleTypes" [value]="roleType.id">{{'site-admin.role.type.' + roleType.name.toLocaleLowerCase() | translate}}</option>
                    </select>
                </div>
            </div>
            <div class="mb-3 row required">
                <label for="roleName" class="col-md-3 col-form-label fw-bold float-end" jhiTranslate="site-admin.role.modal.permissions"></label>
                <div class="col-sm-9">
                    <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                    </span>
                        <input type="text" class="form-control" [(ngModel)]="textFilter"
                               [placeholder]="'site-admin.role.modal.filter.permissions.placeholder' | translate" id="textSearch" name="textSearch">
                        <button class="btn btn-outline-secondary" *ngIf="textFilter" (click)="textFilter=''" aria-label="Clear">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="col-md-3">
                </div>
                <div class="col-sm-9">
                    <div class="permission-selector">
                        <div class="panel-wrapper">
                            <div class="panel panel-primary">
                                <div class="panel-heading"><span jhiTranslate="site-admin.role.modal.dropdown.permission"></span></div>
                                <div class="panel-body">
                                    <jhi-permission-tree [permissions]="permissions"
                                                         [isLevelZero]="true" [textFilter]="textFilter"></jhi-permission-tree>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="!isFormValid(f)">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;
        <span (click)="addRole(f)" *ngIf="!model.id" jhiTranslate="site-admin.role.modal.create.role"></span>
        <span (click)="updateRole(f, true)" *ngIf="model.id" jhiTranslate="site-admin.role.modal.edit.role"></span>
    </button>
</div>
